import ifmTool from '@/utils/ifmTool';
import DownLoad from '@/packages/downLoad/index.js';
import Message from '@/packages/message/index.js';
import store from '@/store/index';
let downLoadHall = false; //是否是下载大厅
let downLoadInstance = null;
let downloadReadyCallback = null; //下载完成的回调

//下载进度回调
const downloadCallback = function(e) {
    const data = JSON.parse(e);
    //如果是下载大厅则就在壳里面处理，否则传到白鹭大厅进行处理
    if (downLoadHall) {
        switch (data.state) {
            case 1:
                if (downLoadInstance != null) {
                    downLoadInstance.update(data.progress);
                }
                break;
            case 2:
                if (downLoadInstance != null) {
                    downLoadInstance.updateText('解压中...');
                }
                break;
            case 3:
                if (downLoadInstance != null) {
                    downLoadInstance.update(100);
                    downLoadInstance.close().then(() => {
                        store.dispatch("setHallZIndex", 3);
                        if (typeof downloadReadyCallback == 'function') {
                            downloadReadyCallback(data.native_url);
                        }
                    });
                }
                break;
            case 4:
                if (downLoadInstance != null) {
                    downLoadInstance.close().then(() => {
                        Message.service({
                            content: '当前网络不好！请重新下载~',
                            confirmText: '重新下载',
                            confirmCallback: () => {
                                window.location.reload();
                            }
                        })
                    });
                }
                break;
        }
    } else {
        switch (data.state) {
            case 1:
                ifmTool.postDownLoadData(data.game_id, data.progress);
                break;
            case 3:
                ifmTool.postDownLoadDataReady(data.game_id);
                break;
            case 4:
                ifmTool.postDownLoadError(data.game_id);
                break;
        }
    }
}
class DownLoadNative {
    constructor(gameID, url, version, isDownLoadHall, callback) {
        this.gameID = gameID;
        this.url = url;
        this.version = version;
        downLoadHall = isDownLoadHall;
        downloadReadyCallback = callback;
    }
    init(defaultDownLoadTxt) {
        window.nativeUtils.download(this.gameID, this.url, this.version);
        window.BSCallback.download = downloadCallback;
        if (downLoadHall) {
            downLoadInstance = DownLoad.service({
                text: defaultDownLoadTxt || ''
            })
        }
    }
}

export default DownLoadNative;